import { render } from "./DetailsModalSkeleton.vue?vue&type=template&id=6cbfd1d7"
import script from "./DetailsModalSkeleton.vue?vue&type=script&lang=js"
export * from "./DetailsModalSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__